import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div className="eb-empty">
      {icon ? <span className="eb-empty__icon">{icon}</span> : null}
      <h2 className="eb-empty__title">{title}</h2>
      {description ? <p className="eb-empty__text">{description}</p> : null}
      {action}
    </div>
  );
}
